import { render, staticRenderFns } from "./ModalCheckDocs.vue?vue&type=template&id=66f8a41e&"
import script from "./ModalCheckDocs.vue?vue&type=script&lang=js&"
export * from "./ModalCheckDocs.vue?vue&type=script&lang=js&"
import style0 from "./ModalCheckDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports